import React, { useState } from "react";

import { getToken } from "../../../../api/Account";
import { updateBonoAsync } from "../../../../api/Employees";
import { useAviso } from "../../../../components/base";
import {
  CampoMonto,
  DialogoFormulario,
  esMontoEscribible,
  useEnvio,
  useEscritura,
} from "../comunes";

const UpdateBono = ({ selected, setShowModal, reload, setReload }) => {
  const [monto, setMonto] = useState(selected.monto);
  const [intentado, setIntentado] = useState(false);

  const token = getToken();
  const aviso = useAviso();
  const escribir = useEscritura();
  const { guardando, enviar } = useEnvio();

  const saveChanges = () =>
    enviar(async () => {
      setIntentado(true);
      if (monto.length === 0) return;

      const data = {
        id: selected.id,
        monto,
      };

      // B11 (se propone aparte): el servidor falla al editar un bono que ya se pagó.
      const ok = await escribir(
        () => updateBonoAsync(token, data),
        "No se pudo actualizar el bono"
      );
      if (!ok) return;
      aviso.exito("Bono actualizado");
      setReload(!reload);
      setShowModal(false);
    });

  const setMontoBono = (montoBono) => {
    if (esMontoEscribible(montoBono)) {
      setMonto(montoBono);
    }
  };

  return (
    <DialogoFormulario
      titulo={`Editar bono #${selected.id}`}
      onCerrar={() => setShowModal(false)}
      hayCambios={monto !== selected.monto}
      guardando={guardando}
      onEnviar={saveChanges}
      textoEnviar="Guardar cambios"
    >
      <CampoMonto
        autoFocus
        required
        label="Monto del bono"
        value={monto}
        onChange={setMontoBono}
        error={intentado && monto.length === 0 ? "Ingrese el monto del bono" : ""}
        disabled={guardando}
        sx={{ mt: 1 }}
      />
    </DialogoFormulario>
  );
};

export default UpdateBono;
